import Cookies from 'js-cookie';
const SITE_NAME = window.siteConfig().siteName;
const NAME = `${SITE_NAME}_cart`;

export const CartCookie = {
    get: () => {
        const values = Cookies.get(NAME);
        return values ? JSON.parse(values) : {};
    },
};
